module.exports = __webpack_public_path__ + "static/img/线下活动-街头装置活动.e13b05b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10011/线下活动-街头装置活动.png
// module id = ZfGG
// module chunks = 1